import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12 col-xxl-12 col-sm-6 mb-10" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "position-relative text-black fw-bold mb-10" }, "Informations")
], -1)
const _hoisted_6 = { class: "table" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Image:")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Valeur:", -1)
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Vision:", -1)
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Mission:", -1)
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Historique:", -1)
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Organigramme:", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Mot du DG:", -1)
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Mention legale:")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Donnée personnelle:")
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Cookie:")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("table", _hoisted_6, [
            _createElementVNode("tbody", null, [
              _hoisted_7,
              _createElementVNode("tr", null, [
                _hoisted_8,
                _createElementVNode("td", {
                  innerHTML: _ctx.apropos?.valeur
                }, null, 8, _hoisted_9)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_10,
                _createElementVNode("td", {
                  innerHTML: _ctx.apropos?.vision
                }, null, 8, _hoisted_11)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_12,
                _createElementVNode("td", {
                  innerHTML: _ctx.apropos?.mission
                }, null, 8, _hoisted_13)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_14,
                _createElementVNode("td", {
                  innerHTML: _ctx.apropos?.historique
                }, null, 8, _hoisted_15)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_16,
                _createElementVNode("td", null, _toDisplayString(_ctx.apropos?.organigramme), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_17,
                _createElementVNode("td", {
                  innerHTML: _ctx.apropos?.annoncedg
                }, null, 8, _hoisted_18)
              ]),
              _hoisted_19,
              _hoisted_20,
              _hoisted_21
            ])
          ])
        ])
      ])
    ])
  ]))
}